<template>
  <div class="activity-main" id="newYearGifts">
    <!--    <headView-->
    <!--      :head-title="$t('300000')"-->
    <!--      go-app='true'-->
    <!--      background="#171717"-->
    <!--      v-if="isApp==1"-->
    <!--    ></headView>-->
    <div class="container">
      <div class="banner">
        <h1>{{ $t('300001') }}</h1>
        <div class="banner-title">{{ $t('300002') }}</div>
      </div>
      <div class="activity-container">
        <div class="activity-content">
          <p class="content" v-html="$t('300003')"></p>
          <p class="time" v-html="$t('300004')"></p>
        </div>
        <div class="activity-detail">
          <div class="detail-title">{{ $t('300005') }}</div>
          <p class="block">
            {{ $t('300006') }}
          </p>
        </div>
        <div class="activity-detail">
          <div class="detail-title">{{ $t('300007') }}</div>
          <p class="block">{{ $t('300008') }}</p>
          <div class="table-title">{{ $t('300025') }}：</div>
          <div class="table-1">
            <div class="table-column">
              <div class="table-row header">{{ $t('300021') }}</div>
              <div class="table-row">500</div>
              <div class="table-row">2000</div>
              <div class="table-row">5000</div>
              <div class="table-row">10000</div>
              <div class="table-row">20000</div>
              <div class="table-row">50000</div>
            </div>
            <div class="table-column">
              <div class="table-row header">{{ $t('300022') }}</div>
              <div class="table-row">0.09%/0.10%</div>
              <div class="table-row">0.08%/0.10%</div>
              <div class="table-row">0.07%/0.10%</div>
              <div class="table-row">0.06%/0.09%</div>
              <div class="table-row">0.05%/0.08%</div>
              <div class="table-row">0.04%/0.07%</div>
            </div>
            <div class="table-column">
              <div class="table-row header">{{ $t('300023') }}</div>
              <div class="table-row">1</div>
              <div class="table-row">5</div>
              <div class="table-row">10</div>
              <div class="table-row">50</div>
              <div class="table-row">100</div>
              <div class="table-row">500</div>
            </div>
            <div class="table-column">
              <div class="table-row header">{{ $t('300024') }}</div>
              <div class="table-row">60</div>
              <div class="table-row">60</div>
              <div class="table-row">60</div>
              <div class="table-row">60</div>
              <div class="table-row">60</div>
              <div class="table-row">60</div>
            </div>
          </div>
          <p class="tips left">{{ $t('300026') }}</p>
        </div>
        <div class="activity-detail">
          <div class="detail-title">{{ $t('300009') }}</div>
          <p class="block">{{ $t('300010') }}</p>
          <div class="table-2">
            <div class="table-header flex-between">
              <div class="th">{{ $t('300017', {coin: 'USDT'}) }}</div>
              <div class="th">{{ $t('300018', {coin: 'ET'}) }}</div>
            </div>
            <div class="table-body">
              <div class="tr flex-between">
                <div class="td">≥ 500</div>
                <div class="td">5</div>
              </div>
              <div class="tr flex-between">
                <div class="td">≥ 1500</div>
                <div class="td">15</div>
              </div>
              <div class="tr flex-between">
                <div class="td">≥ 3000</div>
                <div class="td">50</div>
              </div>
              <div class="tr flex-between">
                <div class="td">≥ 5000</div>
                <div class="td">100</div>
              </div>
              <div class="tr flex-between">
                <div class="td">≥ 20000</div>
                <div class="td">500</div>
              </div>
              <div class="tr flex-between">
                <div class="td">≥ 100000</div>
                <div class="td">3000+VIP6 ({{ $t('300019') }})</div>
              </div>
              <div class="tr flex-between">
                <div class="td">≥ 200000</div>
                <div class="td">8000+VIP7 ({{ $t('300019') }})</div>
              </div>
              <div class="tr flex-between">
                <div class="td">≥ 500000</div>
                <div class="td">30000+VIP8 ({{ $t('300019') }})</div>
              </div>
            </div>
            <p class="left">{{ $t('300020') }}</p>
          </div>
        </div>
        <div class="activity-detail">
          <div class="detail-title">{{ $t('300011') }}</div>
          <p class="left" v-html="$t('300012')"></p>
        </div>
        <div class="share-button">
          <div class="button pointer" @click="handleShare"><i class="iconfont icon-fenxiang"></i>
            {{ $t('300013') }}
          </div>
          <div class="right">
            <p>{{ $t('300014') }}</p>
            <p>{{ $t('300015') }}</p>
          </div>
        </div>
        <div class="activity-footer">
          <p>{{ $t('300016') }}</p>
          <div class="links">
            <svg slot="image" class="icon" aria-hidden="true">
              <use xlink:href="#icon-xiaofeiji"></use>
            </svg>
            <span>https://t.me/SuperExOfficial
              <i class="copy iconfont icon-fuzhi" @click="handleCopy"
                 data-clipboard-text="https://t.me/SuperExOfficial"></i>
            </span>
          </div>
          <div class="links">
            <svg slot="image" class="icon" aria-hidden="true">
              <use xlink:href="#icon-tuite"></use>
            </svg>
            <span>https://twitter.com/SuperExet
              <i class="copy iconfont icon-fuzhi" @click="handleCopy"
                 data-clipboard-text="https://twitter.com/SuperExet"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headView from "../compontents/headView";
import * as configs from "@/../config/config"
import {setCookie, removeCookie, removeToken, getCookie, setToken} from "../utils/auth";
import {Toast} from 'vant'
import {getUserInfo} from "../api/user";
import Clipboard from 'clipboard'

export default {
  name: "newYearGifts",
  components: {headView},
  data() {
    return {
      isApp: '',
      staticState: configs[configs.Edition].staticState,
      userInfo: {},
      isLogin: false, //登录状态
    }
  },
  methods: {
    appLogout() {
      var _this = this
      this.$jsBridge.callHandler(this.$jsBridgeCmd.appLogout, {code: 200}, (data) => {
        _this.isLogin = false
        removeToken()
        removeCookie('userInfo')
      })
    },
    appLogin() {
      if (this.isApp == 1) {
        this.$jsBridge.callHandler(this.$jsBridgeCmd.appLogin, {code: 200, type: 'login'}, (data) => {
        })
        return false
      }
    },
    handleShare() {
      if (this.isLogin) {
        if (this.isApp == 1) {
          this.$jsBridge.callHandler(this.$jsBridgeCmd.goInvite, {code: 200}, (data) => {
          })
        }
      } else {
        if (this.isApp == 1) {
          this.appLogin()
          return false
        }
      }
    },

    getUserInfo() {
      getUserInfo().then(res => {
        if (res.code == 403 || res.code == 413) {
          // Toast('token过期了')
          this.appLogout()
          return false
        }
        if (res.data) {
          this.userInfo = res.data;
          setCookie('userInfo', JSON.stringify(res.data))
        }
      })
    },
    getColor() {
      var that = this
      if (this.isApp == 1) {
        this.$jsBridge.callHandler(this.$jsBridgeCmd.getBackgroundColor, {color: '#171717'}, (data) => {
          if (data == 200) {
            clearInterval(that.MyTime)
            that.MyTime = null
          }
        })
      }
    },
    // 复制
    handleCopy() {
      var clipboard = new Clipboard('.copy')
      clipboard.on('success', e => {
        Toast.success(this.$t('300027'))
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        Toast.fail(this.$t('300028'))
        // 释放内存
        clipboard.destroy()
      })
    },
    resher() {
      this.isApp = this.$route.query.isApp
      var token = this.$route.query.token
      this.language = this.$route.query.language ? this.$route.query.language : 'en'
      // if (token) {
      //     Toast.success('有token')
      // }else{
      //     Toast.fail('没有token')
      // }
      if (this.isApp == 1) {
        this.$i18n.locale = this.language;
        if (token) {
          setToken(token)
          this.isLogin = true
          this.getUserInfo()
        } else {
          removeToken()
          this.isLogin = false
        }
      } else {
        this.isLogin = getCookie('token') ? true : false;
        if (this.isLogin) {
          this.getUserInfo()
        } else {
          removeToken()
        }
      }
    },
  },
  created() {
    this.resher()
    this.getColor()
  },
  watch: {
    $route() {
      // Toast('监听路由变化')
      this.resher()
      this.getColor()
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";

.activity-main {
  .container {
    padding-top: 0;

    .banner {
      @include wh(100%, torem(139));
      background: url("#{$variableName}static/images/activity/newYearGiftsApp/banner.png") no-repeat;
      background-size: cover;
      text-align: center;
      padding-top: torem(36.5);

      h1 {
        @include sc(torem(18), #F1B90A);
        margin-bottom: torem(10);
      }

      .banner-title {
        @include wh(torem(270), torem(33.5));
        line-height: torem(30);
        background: url("#{$variableName}static/images/activity/newYearGiftsApp/title_bg.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        @include sc(torem(12), #333);
        font-weight: bold;
      }
    }

    .activity-container {
      width: 100%;
      min-height: torem(600);
      height: auto;
      background: url("#{$variableName}static/images/activity/newYearGiftsApp/bg.png") no-repeat;
      background-size: cover;
      padding: torem(15.5) 0 torem(40);

      .activity-content {
        p {
          @include sc(torem(12), #F1B90A);
          line-height: 1.5;
          text-align: center;
        }

        p.content {
          margin: 0 auto;
          @include wh(torem(324.5), torem(130));
          padding: torem(10) torem(14);
          background: url("#{$variableName}static/images/activity/newYearGiftsApp/border.png") no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
        }

        p.time {
          margin-top: torem(20);
        }
      }

      .activity-detail {
        @include sc(torem(12), #fff);
        margin-top: torem(31);

        .detail-title {
          @include sc(100%, torem(24));
          line-height: torem(24);
          margin: 0 auto;
          text-align: center;
          background: url("#{$variableName}static/images/activity/newYearGiftsApp/title_border.png") no-repeat;
          background-size: 100% 100%;
          @include sc(torem(12), #F1B90A);
          margin-bottom: torem(20);
        }

        p.block {
          width: torem(323);
          margin: 0 auto;
          line-height: 1.5;
          text-align: center;
        }

        p.left {
          width: torem(323);
          margin: 0 auto;
          line-height: 1.8;
          text-align: left;
        }

        .table-title {
          width: calc(100% - #{torem(30)});
          /*border: torem(1) solid #F1B90A;*/
          height: torem(22);
          line-height: torem(22);
          color: #F1B90A;
          margin: torem(24) auto 0;
          /*text-align: center;*/
        }

        .table-1 {
          padding: 0 torem(15);
          display: flex;
          justify-content: space-between;
          align-items: center;

          .table-column {
            width: 24.6%;

            .table-row {
              border: torem(1) solid #B1B9C8;
              height: torem(22);
              line-height: torem(22);
              margin-top: torem(1);
              font-size: torem(11);
              text-align: center;
            }

            .header {
              border-color: #F1B90A;
              color: #F1B90A;
            }

          }
        }

        p.tips {
          width: 100%;
          padding-left: torem(15);
          text-align: left;
          margin: torem(10) 0 0;
          color: #F1B90A;
          @include sc(torem(10), #F1B90A);
        }

        .table-2 {
          width: 100%;
          margin: torem(20) auto 0;
          padding: 0 torem(15);

          .flex-between {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .th {
            height: torem(22);
            line-height: torem(20);
            border: torem(1) solid #F1B90A;
            @include sc(torem(11), #F1B90A);
            text-align: center;
            width: 49.8%;
          }

          .tr {
            margin-top: torem(1);
          }

          .td {
            height: torem(22);
            border: torem(1) solid #B1B9C8;
            @include sc(torem(11), #fff);
            line-height: torem(22);
            text-align: center;
            width: 49.8%;
          }

          .left {
            margin: torem(10) 0 0;
            @include sc(torem(10), #F1B90A);
          }
        }
      }

      .share-button {
        padding: 0 torem(15);
        width: 100%;
        border-bottom: torem(1) solid #F1B90A;
        text-align: center;
        margin: torem(30) auto 0;

        .button {
          @include wh(torem(132), torem(37));
          line-height: torem(37);
          background: url("#{$variableName}static/images/activity/newYearGiftsApp/button_bg.png") no-repeat;
          background-size: 100% 100%;
          @include sc(torem(16), #333);
          margin: 0 auto;
          font-weight: bold;

        }

        div.right {
          height: auto;
          text-align: right;
          margin: torem(10) 0 torem(10);
          @include sc(torem(12), #F1B90A);

          p {
            line-height: 1.5;
          }
        }
      }

      .activity-footer {
        padding: 0 torem(15);
        width: 100%;
        margin: torem(10) auto 0;
        text-align: left;

        p {
          @include sc(torem(12), #F1B90A);
          margin-bottom: torem(10);
          line-height: 1.5;
        }

        .links {
          display: flex;
          align-items: center;
          margin-top: torem(10);

          svg {
            @include wh(torem(20), torem(20));
            margin-right: torem(10);
          }

          span {
            @include sc(torem(12), #F1B90A);

            i {
              margin-left: torem(5);
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/newYearGifts.vue